import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as i, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCast",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0V3A1.5 1.5 0 0 1 2 1.5h8A1.5 1.5 0 0 1 11.5 3v6a1.5 1.5 0 0 1-1.5 1.5H7a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2Z",
  "clip-rule": "evenodd"
}, null, -1), u = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.503 5.947a.5.5 0 0 1 .55-.444 5 5 0 0 1 4.444 4.444.5.5 0 0 1-.994.106A4 4 0 0 0 .947 6.497a.5.5 0 0 1-.444-.55Z",
  "clip-rule": "evenodd"
}, null, -1), h = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.508 7.908a.5.5 0 0 1 .584-.4 3 3 0 0 1 2.4 2.4.5.5 0 0 1-.984.184 2 2 0 0 0-1.6-1.6.5.5 0 0 1-.4-.584ZM.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  _,
  u,
  h
];
function m(t, p, r, v, C, e) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--cast"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Cast",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, f, 10, c);
}
const S = /* @__PURE__ */ n(s, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=cast.js.map
